exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--1HV0fCxfyqDAVffdQ8CLfG {\n  display: flex;\n  align-items: flex-start;\n  padding: 10px 16px 6px 16px;\n  font-size: .875rem;\n  line-height: 1.5rem;\n  color: #5b2f91;\n  border-bottom: 1px solid #7d7d7d;\n  box-sizing: border-box;\n  margin: -1rem -1rem -0.5rem -1rem;\n}\n\n.waiting-room-sidebar--3VwSdFM6xff8BvFNK3M8So {\n  background: #5b2f91;\n  color: #fff;\n  border-bottom-color: #5b2f91;\n}\n\n.waiting-room-sidebar--1PlMt5iKkrnBeq3wUSyO6l {\n  width: 100%;\n}\n\n.waiting-room-sidebar--352pDWUPI1tg1i1XdPrDWc {\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n  margin-left: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"conferenceStatusContainer": "waiting-room-sidebar--1HV0fCxfyqDAVffdQ8CLfG",
	"conferenceStatusContainer": "waiting-room-sidebar--1HV0fCxfyqDAVffdQ8CLfG",
	"conferenceActive": "waiting-room-sidebar--3VwSdFM6xff8BvFNK3M8So",
	"conferenceActive": "waiting-room-sidebar--3VwSdFM6xff8BvFNK3M8So",
	"conferenceStatus": "waiting-room-sidebar--1PlMt5iKkrnBeq3wUSyO6l",
	"conferenceStatus": "waiting-room-sidebar--1PlMt5iKkrnBeq3wUSyO6l",
	"conferenceDuration": "waiting-room-sidebar--352pDWUPI1tg1i1XdPrDWc",
	"conferenceDuration": "waiting-room-sidebar--352pDWUPI1tg1i1XdPrDWc"
};